
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/[[...path]]",
      function () {
        return require("private-next-pages/auth/[[...path]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/[[...path]]"])
      });
    }
  